var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{attrs:{"header":"Plot: Lines "}},[_c('svg-plot',{staticClass:"mt3",attrs:{"config":_vm.config}},[_c('svg-line',{attrs:{"data":_vm.line}}),_c('svg-line',{attrs:{"data":_vm.line2}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }